import { render, staticRenderFns } from "./PostView.vue?vue&type=template&id=abfea174&"
import script from "./PostView.vue?vue&type=script&lang=ts&"
export * from "./PostView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports